<ng-container *ngIf="invoice && invoice.archived">
<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
  <div fxFlex="100">
        <div class="" fxLayout="row" style="color: red; background-color: yellow; font-size: 1.5em; padding: 20px; text-align: center">
          <label fxFlex="100">
            <mat-icon>delete</mat-icon> <strong>Invoice was deleted</strong>

          </label>

          <button mat-button color="basic" *ngIf="invoice != null && invoice.archived" [disabled]="!deleteEnabled()"
                  (click)="restoreInvoice()"><mat-icon>undo</mat-icon> Restore</button>

        </div>

  </div>
</div>
</ng-container>

<div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">

  <div fxFlex="50">

    <mat-card class="content-card" *ngIf="invoice && invoice.customer">
      <mat-card-content>


        <div class="" fxLayout="row">
          <label fxFlex="35" class="secondary">Customer</label>
          <label fxFlex="65">
            <a routerLink="/customers-overview/{{ invoice.customer.id }}">{{ invoice.customer.firstName }} {{ invoice.customer.lastName }} </a><br />
            {{ invoice.customer.address }}<br />
            {{ invoice.customer.zipCode }} {{ invoice.customer.city }}<br />
            {{ invoice.customer.countryName }}
          </label>
        </div>
        <div class="" style="margin-top: 10px;" fxLayout="row" *ngIf="invoice && invoice.card">
          <label fxFlex="35" class="secondary" *ngIf="invoice && invoice.card">Token</label>
          <label fxFlex="65" *ngIf="invoice && invoice.card">
           {{ invoice.card.token }}
          </label>

        </div>
      </mat-card-content>
    </mat-card>


    <mat-card class="content-card">
      <mat-card-content>

        <span (click)="returnBack()" style="cursor: pointer; margin-right: 15px;">◀️ Go back</span>

        <div [hidden]="invoice">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>

        <div style="color: red; margin-bottom: 10px; font-weight: bold; text-align: left;"
             *ngIf="invoice != null && invoice.debtorDistributionId != null && invoice.debtorDistribution != null && invoice.debtorDistribution.type == 'CashBro'">
          Invoice was transferred to CashBro
        </div>
        <div style="color: red; margin-bottom: 10px; font-weight: bold; text-align: left;"
             *ngIf="invoice != null && invoice.debtorDistributionId != null && invoice.debtorDistribution != null && invoice.debtorDistribution.type == 'Pair Finance'">
          Invoice was transferred to Pair Finance - current
          state: {{ invoice.paidStatePairFinance == null ? "unknown" : invoice.paidStatePairFinance }}
        </div>

        <div class="list-item list-item-header" fxLayout="row">
          <label fxFlex="35" class="secondary">Invoice</label>
          <label fxFlex="65" *ngIf="invoice">{{ invoice.code }}</label>
        </div>
        <div class="list-item" fxLayout="row" *ngIf="invoice && invoice.firstOrder">
          <label fxFlex="35" class="secondary">Order</label>
          <label fxFlex="65" *ngIf="invoice && invoice.ordersCount === 1"><a
            routerLink="/orders/{{ invoice.firstOrder.id }}">{{ invoice.firstOrder.id }}
            - {{invoice.firstOrder.firstName }} {{invoice.firstOrder.lastName }}</a></label>
          <label fxFlex="65" *ngIf="invoice && invoice.ordersCount > 1">({{invoice.ordersCount}} orders)</label>
        </div>
        <ng-container *ngFor="let field of fields">
          <div class="list-item" fxLayout="row"  *ngIf="field.hidden == null || field.hidden(invoice) == false">
              <app-content-row [field]="field" [entity]="invoice"></app-content-row>
          </div>
        </ng-container>
        <div class="list-item" fxLayout="row">
          <label fxFlex="35" class="secondary">Company</label>
          <label fxFlex="65" *ngIf="invoice && invoice.firstOrder && invoice.firstOrder.product"><a
            routerLink="/companies/{{ invoice.firstOrder.product.companyId }}">{{ invoice.firstOrder.product.companyName }}</a></label>
        </div>




      </mat-card-content>
      <mat-card-actions>

          <div class="left-side-button">
            <button *ngIf="invoice?.pdfId"
                    mat-raised-button
                    color="primary"
                    (click)="downloadAttachment()"
            >
              Download PDF
            </button>
            <button *ngIf="!(invoice?.pdfId)"
                    mat-raised-button
                    color="primary"
                    (click)="createInvoicePdf()"
            >
              Generate PDF
            </button>

            <button *ngIf="invoice?.pdfId"
                    mat-raised-button
                    color="blue"
                    (click)="previewInvoiceFile(invoice!.id)">

              Preview
            </button>

            <button  [disabled]="!(invoice?.pdfId)"
                     mat-raised-button
                     color="blue"
                     (click)="resendInvoice(invoice!.id)">

              Re-Send
            </button>

            <button *ngIf="!invoice.paid"  [disabled]="invoice?.debtorDistributionId != null"
                     mat-raised-button
                     color="blue"
                     (click)="chooseDunningStopDate()">

              Dunning Stop
            </button>

          </div>


          <div class="right-side-button">

            <!--<button mat-raised-button color="primary"
                    [disabled]="invoice == null || (invoice != null && invoice.debtorDistributionId != null)"
                    *ngIf="currentUserIsAdmin()" (click)="edit()">Edit
            </button>-->



            <button mat-raised-button color="warn" style="margin-right: 50px;" *ngIf="invoice != null && !invoice.archived" [disabled]="!deleteEnabled()"
                    (click)="deleteInvoice()"><mat-icon>delete</mat-icon></button>

            <button mat-raised-button color="primary" [disabled]="!prevNext?.prev"
                    (click)="gotoPrevInvoice()">&lt;</button>
            <button mat-raised-button color="primary" [disabled]="!prevNext?.next" (click)="gotoNextInvoice()">&gt;</button>

          </div>


      </mat-card-actions>
    </mat-card>

    <div *ngIf="previewFileOpen">
      <mat-card *ngIf="invoice" class="content-card">
        <mat-card-header>
          <mat-card-title-group>
            <mat-card-title>
              <h5 *ngIf="previewFilename == null">Preview</h5>
              <h5 *ngIf="previewFilename != null">{{ previewFilename }}</h5>

              <mat-error *ngIf="previewErrorMsg != null">{{previewErrorMsg}}</mat-error>
            </mat-card-title>
          </mat-card-title-group>
          <div fxFlex></div>
          <div fxLayoutAlign="center center">
            <button mat-flat-button (click)="closePreview()"><mat-icon>clear</mat-icon> Close</button>
          </div>

        </mat-card-header>
        <mat-card-content style="">

          <!--
          <div class="resp-container">
            <iframe class="resp-iframe" src="https://www.youtube.com/embed/dQw4w9WgXcQ" gesture="media"  allow="encrypted-media" allowfullscreen [hidden]="isFrameHidden" frameBorder="1" [src]="urlSafe"></iframe>
          </div>
          -->

          <iframe class="resp-iframe" height="1000" width="100%" frameBorder="1" *ngIf="this.previewType === 1" [src]="previewUrlSafe" ></iframe>
          <img [src]="previewUrlSafe" style="width: 100%; height:auto;" *ngIf="this.previewType === 2" />



        </mat-card-content>
      </mat-card>
    </div>


  </div>
  <div fxFlex="50">

    <mat-card *ngIf="invoice && invoice.paid" class="content-card" style="padding: 0; border: 1px solid darkgreen;">
      <mat-card-content>
        <div style="background-color: lightgreen;  padding: 15px 3px; border-radius: 5px;">
          ✅️ This invoice is marked as paid.
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card *ngIf="invoice && invoice.debtorDistributionId" class="content-card" style="padding: 0; border: 1px solid orange;">
      <mat-card-content>
        <div style="background-color: yellow;  padding: 15px 3px; border-radius: 5px;">
          🕵️‍♂️ This invoice was transferred to a collection agency
        </div>
      </mat-card-content>
    </mat-card>


    <mat-card class="content-card">
      <mat-card-content>
        <div [hidden]="invoice">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        <div *ngIf="invoice && invoice.invoiceLineItems">
          <table class="list-table" style="word-wrap:break-word; table-layout: fixed;">
            <tr>
              <th class="" style="text-align: left; width: 150px;"><label>Quantity</label></th>
              <th style="text-align: left; width: 120px;"><label>Name</label></th>
              <th style="text-align: right; width: 120px;"><label>Single amount</label></th>
              <th style="text-align: right; width: 120px;"><label>Amount</label></th>
            </tr>
            <tr *ngFor="let item of invoice.invoiceLineItems; let i = index;">
              <td>{{ item.numberOfItems }}</td>
              <td>{{ item.name }}</td>
              <td style="text-align: right;">€ {{ item.singleAmount | number: '1.2-2'  }}</td>
              <td style="text-align: right;">€ {{ item.amount | number: '1.2-2'  }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="border-top: 1px solid black;text-align: right;">
                Vat {{ invoice.vatRateAtCreation | number: '1.2-2'  }} %
              </td>
              <td
                style="border-top: 1px solid black;text-align: right;">{{ (invoice.billAmount - (invoice.billAmount / ((invoice.vatRateAtCreation + 100) / 100))) | number: '1.2-2' }}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="border-top: 2px solid black;text-align: right; font-weight: bold">Sum</td>
              <td style="border-top: 2px solid black;text-align: right; font-weight: bold">
                € {{ invoice.billAmount | number: '1.2-2' }}</td>
            </tr>
          </table>
        </div>
      </mat-card-content>
    </mat-card>

    <app-object-comments-view *ngIf="invoice && !currentUserIsPartner()" [comments]="comments" [objectId]="invoice?.id"
                              [target]="commentsTarget"></app-object-comments-view>

    <mat-card class="content-card" *ngIf="(currentUserIsAdmin() || currentUserIsCompliance()) && (debtorlogs != null && debtorlogs.length > 0) && invoice" >
      <mat-card-header>
        <mat-card-title>
          <h5>Debtor Logs</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <strong>send attemts:</strong> {{ invoice.sentAttempts }} &nbsp;&nbsp;&nbsp;
        <span [hidden]="!currentUserIsAdmin()">
          <button  mat-raised-button mat-button (click)="resetSentAttemts()" [disabled]="invoice.paid || invoice.debtorDistributionId != null || (invoice.sentAttempts != null && invoice.sentAttempts <= 15)" color="warn" >
            <mat-icon>restore_from_trash</mat-icon> Reset
          </button>
        </span>

        <br /><br />

        <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
          <label fxFlex="20" class="secondary">Date</label>
          <label fxFlex="80" class="secondary">Error</label>
        </div>
        <div class="list-item" fxLayoutAlign="left center" fxLayout="row" fxLayoutGap="10px" *ngFor="let log of debtorlogs" >
          <div class="" fxFlex="20" >{{ log.date | date: "dd.MM.yyyy HH:mm" }}</div>
          <div class="" fxFlex="80" >
            <div *ngFor="let error of log.pairFinanceErrors">
              {{ error == null || error == "" ? "unkown" : error }}
            </div>
            <div *ngIf="log.pairFinanceErrors == null">
              unknown
            </div>
          </div>
        </div>


      </mat-card-content>
    </mat-card>

    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>Payments</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>

        <div *ngIf="currentUserIsAdmin() && paymentForm" [formGroup]="paymentForm">
          <app-date-edit formControlName="date" placeholder="Date" required></app-date-edit>

          <mat-form-field>
            <input matInput placeholder="Amount" formControlName="amount" type="number" required>
          </mat-form-field>

          <div [hidden]="!isPaymentSaving">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
          <div style="width: 100%; text-align: right;" [hidden]="isPaymentSaving">

            <button mat-raised-button color="primary" type="submit" (click)="onPaymentSubmit()"
                    [disabled]="!invoice && editEnabled() && (!paymentForm.valid || paymentForm.pristine)">add
            </button>
          </div>
        </div>

        <br /><br />

        <div [hidden]="!isLoadingPayments">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        <div class="list-item" fxLayout="row" fxLayoutGap="10px">
          <label fxFlex="20" class="secondary">Date</label>
          <label fxFlex="16" class="secondary">Amount</label>
          <label fxFlex="16" class="secondary">Pair Fin.</label>


        </div>
        <div id="scroll" [hidden]="isLoadingPayments">
          <div class="list-item" fxLayoutAlign="left center" fxLayout="row" fxLayoutGap="10px"
               *ngFor="let payment of payments">
            <div class="" fxFlex="20">{{ payment.date | date: "dd.MM.yyyy HH:mm" }}</div>
            <div class="" fxFlex="16">{{ payment.amount }}</div>
            <label fxFlex="16" class="">
              <mat-icon *ngIf="payment.isSentToPairFinance">done</mat-icon>
            </label>
            <div class="" fxFlex="10">
              <button *ngIf="currentUserIsAdmin()" mat-icon-button [disabled]="payment.isSentToPairFinance" (click)="deletePayment(payment.id)">
                <mat-icon style="color: orangered;">delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions align="end">

      </mat-card-actions>
    </mat-card>


  </div>
</div>
